import { Component, input } from '@angular/core';
import { Message } from '../../chat.model';
import { MarkdownComponent } from 'ngx-markdown';
import { MatTooltip } from '@angular/material/tooltip';
import { ButtonDirective } from '@innersource/common-ui-components';

/** Renders an expert response and its copy action. */
@Component({
  selector: 'app-agent-message',
  standalone: true,
  imports: [MarkdownComponent, MatTooltip, ButtonDirective],
  templateUrl: './agent-message.component.html',
  styleUrl: './agent-message.component.scss',
})
export class AgentMessageComponent {
  /** Inputs. */
  readonly message = input.required<Message>();
  readonly isStreaming = input(false);

  /** Copies the response text. */
  onCopy(): void {
    void navigator.clipboard.writeText(this.message().text);
  }
}
